import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../providers/auth.service';


export class GuestComponent implements OnInit {

	constructor(private authService: AuthService) { }

	/* Lifecycle events */
	public ngOnInit(): void {
		this.authService.setUserTypeNavigation('guest');
	}

	/* Events */

	/* Services calls */

	/* Helpers */
static ctorParameters() { return [ { type: AuthService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/guest.component.ts